<template>
  <div>
    <div class="update-email-form" v-if="submitted">
      <div class="update-email-form-title">Xác nhận mã OTP</div>
      <label class="update-email-form-label">Nhập mã OTP bạn vừa nhận được</label>
      <div class="digit-group">
        <OTPInput
          ref="otpInput"
          :isDisabled="false"
          :isError="false"
          :onChangeOTP="onChangeOTP"
          :shouldResetOTP="true"
          :numberOfInput="6"
        />
        <p class="update-email-form-text update-email-form-text--error">{{errorOTP}}</p>
      </div>
      <div class="update-email-form-bottom">
        <button type="button" class="update-email-form-button update-email-form-button--primary" @click="updateEmail" :disabled="isRequest">
          <vue-element-loading :active="isRequest"/>
          Xác nhận
        </button>
        <div class="text-center underline">
          <a href="#" @click="requestResendOtp">
            <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
              <template slot-scope="props">Vui lòng thử lại sau {{ props.totalSeconds }} giây</template>
            </countdown>
            <span v-else>Gửi lại mã OTP</span>
          </a>
        </div>
        <p class="update-email-form-step-number">2/2</p>
      </div>
    </div>
    <div class="update-email-form" v-else>
      <div class="update-email-form-title">Thay đổi Email</div>
      <label class="update-email-form-label">Nhập email mới</label>
      <input type="Email" placeholder="Email mới"  class="update-email-form-input" v-model="newEmail">
      <p class="update-email-form-text update-email-form-text--error" v-if="$v.newEmail.$error && !$v.newEmail.email">Định dạng email không đúng</p>
      <p class="update-email-form-text update-email-form-text--error" v-if="$v.newEmail.$error && !$v.newEmail.required">Vui lòng nhập email</p>
      <div class="update-email-form-bottom">
        <button type="button" class="update-email-form-button update-email-form-button--primary" @click="requestUpdateEmail" :disabled="isRequest">
          <vue-element-loading :active="isRequest"/>
          Xác nhận
        </button>
        <p class="update-email-form-step-number">1/2</p>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import OTPInput from '@/components/OTPInput.vue'
import Countdown from '@/components/Countdown'
import { AuthService } from '@/services/auth.service'
import { UsersService } from '@/services/users.service'
export default {
  name: 'UpdateEmailForm',
  mixins: [validationMixin],
  components: {
    OTPInput,
    Countdown
  },
  data () {
    return {
      otp: '',
      errorOTP: '',
      newEmail: '',
      submitted: false,
      counting: false,
      isRequest: false
    }
  },
  validations: {
    newEmail: { required, email }
  },
  methods: {
    requestUpdateEmail () {
      this.isRequest = true
      this.$v.newEmail.$touch()
      if (this.$v.newEmail.$invalid) {
        this.isRequest = false
        return
      }
      AuthService.resendOTPByToken().then(response => {
        if (response.data.data.IsResult === false) {
          this.isRequest = false
          this.$store.commit('toast/NEW', { type: 'error', message: response.data.Message })
          return
        }
        this.isRequest = false
        this.submitted = true
        this.$nextTick(() => {
          this.$refs.otpInput.focusFirstInput()
        })
      }).catch((error) => {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    updateEmail () {
      this.isRequest = true
      AuthService.confirmOTPByToken(this.otp).then(response => {
        if (response.data.data.IsResult === false) {
          this.errorOTP = response.data.Message
          this.isRequest = false
          return
        }
        this.errorOTP = ''
        UsersService.updateProfile({ Email: this.newEmail }).then(response => {
          if (response.data.data.IsResult === false) {
            this.$store.commit('toast/NEW', { type: 'error', message: response.data.Message })
            this.isRequest = false
            this.closeForm()
            return
          }
          this.$store.dispatch('user/getCurrent')
          this.$store.commit('toast/NEW', { type: 'success', message: 'Email đã cập nhật thành công' })
          this.isRequest = false
          this.closeForm()
        }).catch(error => {
          this.isRequest = false
          this.closeForm()
          this.$store.commit('toast/NEW', {
            type: 'error',
            message: error.message
          })
        })
      }).catch((error) => {
        this.isRequest = false
        this.closeForm()
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    handleCountdownEnd: function () {
      this.counting = false
    },
    requestResendOtp () {
      if (this.counting === true) return
      this.counting = true
      AuthService.resendOTPByToken().then(response => {
        if (response.data.data.IsResult === false) {
          this.errorOTP = response.data.Message
          return
        }
        this.errorOTP = ''
        this.$store.commit('toast/NEW', { type: 'success', message: response.data.Message })
      }).catch((error) => {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    },
    onChangeOTP (otp) {
      this.otp = otp
    },
    closeForm () {
      this.$emit('closeForm')
    }
  }
}
</script>
